export const forumData = [
  {
    path: "/apply/forum/18/forumHome",
    name: "论坛首页"
  },
  {
    path: "/apply/forum/18/forumList",
    name: "论坛列表"
  },
  {
    path: "/apply/forum/18/userList",
    name: "用户列表"
  },
  {
    path: "/apply/forum/18/blacklist",
    name: "黑名单"
  },
  {
    path: "/apply/forum/18/lanternSlide",
    name: "幻灯片"
  },
  {
    path: "/apply/forum/18/classList",
    name: "分类列表"
  },
  {
    path: "/apply/forum/18/comment",
    name: "评论管理"
  },
  {
    path: "/apply/forum/18/search",
    name: "搜索设置"
  },
  {
    path: "/apply/forum/18/basicsSetting",
    name: "基础设置"
  },
  {
    path: "/apply/forum/18/advertisement",
    name: "广告管理"
  },
  {
    path: "/apply/forum/18/announcement",
    name: "公告管理"
  },
  {
    path: "/apply/forum/18/report",
    name: "帖子举报"
  },
  {
    path: "/apply/forum/18/homeRecommend",
    name: "首页推荐设置"
  },
  {
    path: "/apply/forum/18/sensitiveFilter",
    name: "敏感词过滤"
  }
];
